const {KitModule, registerModule} = window;

class LogoCloud extends KitModule {
  constructor($element) {
    super($element);

    this.isExpanded = false;
    this.labelCollapsed = 'View More';
    this.labelExpanded = 'View Less';

    this.bindEvents();
    this.updateUI();
  }

  bindEvents() {
    this.$toggle?.addEventListener('click', this.handleToggle.bind(this));
  }

  handleToggle() {
    this.isExpanded = !this.isExpanded;
    this.$toggle.setAttribute('aria-expanded', this.isExpanded);
    this.$images.setAttribute('data-expanded', this.isExpanded);

    this.updateUI();
  }

  unmount() {}

  updateUI() {
    if (this.$toggleLabel) {
      this.$toggleLabel.innerText = this.isExpanded ? this.labelExpanded : this.labelCollapsed;
    }
  }
}

registerModule('LogoCloud', LogoCloud);
